import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import './Nav.css'
import LegendLayers from '../Legend/LegendLayers'

const Icon = props => {
    let icon = `c-light-blue-500m`;
    return props ?  (
        <span className='icon-holder'><i className={ icon }></i></span>
    ) : null
}
const NavBar = props => {
    const [ selectedLayer, setSelectedLayer ] = useState('indice_dependencia' )
    const { children, dispatch, layersDispatch } = props
    const onClick = (evt,val) => {
        const view = layersDispatch.view || val
        if (!layersDispatch.view.includes('indice')) {
            dispatch.layers.loadDatabaseLayer({endpoint: 'indices_pob', value: val, view: val })
        }
        setSelectedLayer(view)
        dispatch.layers.passLayerView(val)
    }
    const requestLayer = (evt, props) => {
        const { endpoint, key } = props
        dispatch.layers.loadDatabaseLayer({...props, view: key })
    }
    return (
        <div className='navigation features-container'>
            <div className="sidebar-layers">
                <div className="sidebar-header" onClick={ evt => requestLayer(evt, { endpoint: 'ivs', key:  'ind_vul'})}>
                    <h3>Indice de Vulnerabilidad Social</h3>
                    <LegendLayers name='ind_vul' />
                </div>
                <ul className="nav-links">
                    <div>
                        <li className='li-layer'><Link onClick={ evt => onClick(evt, 'indice_dependencia') }>Indice de dependencia</Link></li>
                        <LegendLayers name='indice_dependencia' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => onClick(evt, 'indice_dependencia_de_menor_15') }>Indice de dependencia : menor a 15</Link></li>
                        <LegendLayers name='indice_dependencia_de_menor_15' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => onClick(evt, 'indice_dependencia_de_mayor_65') }>Indice de dependencia : mayor a 65</Link></li>
                        <LegendLayers name='indice_dependencia_de_mayor_65' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => onClick(evt, 'indice_envejecimiento') }>Indice de envejecimiento</Link></li>
                        <LegendLayers name='indice_envejecimiento' />
                    </div>
                    <div>
                    {/*<li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'income', key: 'y2023' }) }>Renta media neta por persona</Link></li>*/}
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'poblacion', key: 'habitantes_por_parcela_promedio' }) }>Promedio de personas por parcela</Link></li>
                        <LegendLayers name='habitantes_por_parcela_promedio' />
                    </div>
                </ul>
                <div className="sidebar-header" onClick={ evt => requestLayer(evt, { endpoint: 'iaeu', key: 'idx_acceso'})}>
                    <h3>Access a Equipamientos Urbanos</h3>
                    <LegendLayers name='idx_acceso' />
                </div>
                <ul className="nav-links">
                    <div>
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'pendiente', key: 'clasificacion_de_pendiente' }) }>Pendiente Clasificado</Link></li>
                        <LegendLayers name='clasificacion_de_pendiente' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'iso_deportes', key: 'distancia_peatonal' }) }>Isócronas: Distancia peatonal a equipos deportivos</Link></li>
                        <LegendLayers name='distancia_peatonal' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'iso_bus_peatonal', key: 'peatonal_bus_clase' }) }>Isócronas: Distancia peatonal a paradas de bus</Link></li>
                        <LegendLayers name='peatonal_bus_clase' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'iso_coche_edu', key: 'coche_educacion_clase' }) }>Isócronas: Distancia en coche a centros educativos</Link></li>
                        <LegendLayers name='coche_educacion_clase' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint:'iso_coche_health', key: 'coche_salud_clase' }) }>Isócronas: Distancia en coche a centro de salud</Link></li>
                        <LegendLayers name='coche_salud_clase' />
                    </div>
                </ul>
                <div className="sidebar-header" onClick={ evt => requestLayer(evt, { endpoint: 'icuc', key: 'idx_urbano' })}>
                    <h3>Condición Urbano-Catastral</h3>
                    <LegendLayers name='idx_urbano' />
                </div>
                <ul className="nav-links">
                    <div>
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'def_equ', key: 'deficit_de_equipamientos_valor' }) }>Déficit de equipamientos</Link></li>
                        <LegendLayers name='deficit_de_equipamientos_valor' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'def_veg', key: 'deficit_de_vegetacion_promedio' }) }>Presencia de zonas verdes</Link></li>
                        <LegendLayers name='deficit_de_vegetacion_promedio' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'den_urb', key: 'densidad_urbana_promedio' }) }>Densidad urbana</Link></li>
                        <LegendLayers name='densidad_urbana_promedio' />
                    </div>
                    <div>
                        <li className='li-layer'><Link onClick={ evt => requestLayer(evt, { endpoint: 'uso_sue', key: 'id_use' }) }>Usos de suelo</Link></li>
                        <LegendLayers name='id_use' />
                    </div>
                </ul>
                <div className="sidebar-header"
                     style={{ backgroundColor: 'grey', border: '1px solid grey', color: '#EEEEEE', borderRadius: '5px' }}
                     onClick={ evt => requestLayer(evt, { endpoint: 'iicu', key: 'idx_iicu' })}>
                    <h3 style={{color: 'white'}}>Índice Integrado de Calidad Urbana</h3>
                    <LegendLayers name='idx_iicu' />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = () => (
    dispatch => ({
        layersDispatch: dispatch.layers
    })
)

export default connect(mapStateToProps)(NavBar)
